export default {
  de: {
    add: 'Funktion hinzufügen',
    name: 'Name',
    categories: 'Kategorien',
    types: 'Funktionen',
  },
};
